import React, {useState} from "react";
import loginBackground from "../../assets/img/background_login_transparent_small.png";
import {FormattedMessage} from "react-intl";
import * as UserService from "../../services/UserService";
import backImg from "../../assets/img/icon_back.svg";
import {PATH} from "../../routes/routes";
import {useLocation, useNavigate} from "react-router";

function Register() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const redirectUrlAfterLogin = query.get('redirect');
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone:"",
        birthDay: null,
        gender: null,
        calendarIsVisible: false,
        selectedDate: null,
        isSubmitBtnEnabled: true,
        forgotPasswordPopupVisible: false,
        forgotPasswordEmail: "",
        activateAccountPopupStyle: hidden,
    });


    const goBack = () => {
        if (redirectUrlAfterLogin) {
            //TODO useNavigate with search params
            navigateTo({
                pathname: PATH.LOGIN,
                search: "?redirect="+redirectUrlAfterLogin,
            });

        } else {
            navigateTo(-1);
        }
    }

    const validateInputs = () => {
        if (state.firstName === null || state.firstName === "" || state.lastName === null || state.lastName === "") {
            return <FormattedMessage id="FirstNameLastNameCannotBeBlank"/>
        }else if (state.email === null || state.email === "") {
                return <FormattedMessage id="PleaseEnterAvalidEmail"/>
        } else if (state.password === null || state.password === "") {
            return <FormattedMessage id="PleaseEnterAvalidPassword"/>
        } else {
            return null;
        }
    }


    const handleOnChange = (e, input) => {
        if (input === "firstName") {
            setState({
                ...state,
                firstName: e.target.value
            })
        } else if (input === "lastName") {
            setState({
                ...state,
                lastName: e.target.value
            })
        } else if (input === "email") {
            setState({
                ...state,
                email: e.target.value
            })

        } else if (input === "password") {
            setState({
                ...state,
                password: e.target.value
            })

        } else if (input === "birthDay") {
            setState({
                ...state,
                birthDay: e.target.value
            })
        } else if (input === "gender") {
            setState({
                ...state,
                gender: e.target.value
            })
        }
    }


    const registerAccount = async () => {
        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }

        const body = {
            "firstName": state.firstName !== "" ? state.firstName : null,
            "lastName": state.lastName !== "" ? state.lastName : null,
            "email": state.email,
            "password": state.password,
            "phone": state.phone,
            "birthDay": state.birthDay ? new Date(state.birthDay) : null,
            "gender": state.gender ? state.gender : null,
        }

        const response = await UserService.signUpWithEmailAndPassword(body);
        if (response.ok) {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: null,
                loading: false,
                activateAccountPopupStyle: visible,
            })
        } else {
            if (response.data.code === 409) {
                setState({
                    ...state,
                    errorMsg: response.data.error,
                    loading: false,
                })
            } else {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="Error.genericError"/>,
                    loading: false,
                })
            }
        }
    }

    const closeModal = () => {
        setState({
            ...state,
            activateAccountPopupStyle: hidden,
        })
        //TODO useNavigate with search params
        navigateTo({
            pathname:  PATH.LOGIN,
            search: "?redirect="+redirectUrlAfterLogin,
        });
    }


    return (
        <div className="page-content without-actionsbar">
            <div className={state.activateAccountPopupStyle + " modal-overlay "} onClick={(e) => closeModal()}></div>
            <div className="modal activate-account-modal">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="SuccessfulRegistration"/></div>
                </div>
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="RegistrationPendingMsg"/></p>
                </div>


                <div className="row buttons-row">
                    <a className="link" onClick={() => closeModal()}><FormattedMessage id="Ok"/></a>
                </div>

                {state.errorMsgPopup != null ?
                    <>
                        <br/>
                        <div className="error-div full-width">
                            <p>&#9888;&nbsp;{state.errorMsgPopup}</p>
                        </div>
                    </>
                    : null
                }
            </div>


            <div className="login-container">
                <a className="btn-back" onClick={goBack}><img alt="back button" src={backImg}/></a>
                <div className="login-container-top-img">
                    <img alt="background image" src={loginBackground} alt="login background"/>
                </div>
                <div className="login-container-welcome-text">
                    <FormattedMessage id="Welcome"/>
                </div>
                <div className="login-container-content text-left">
                    <div className="form-group">
                        <div className="row">
                            <label>{<FormattedMessage id="FirstName"/>}</label>
                            <FormattedMessage id="FirstName" defaultMessage="FirstName">
                                {placeholder =>
                                    <input
                                        className="input"
                                        type="text"
                                        onChange={e => handleOnChange(e, "firstName")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="firstName"
                                        data-qa="register-page-firstname-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="LastName"/>}</label>
                            <FormattedMessage id="LastName" defaultMessage="LastName">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="text"
                                        onChange={e => handleOnChange(e, "lastName")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="lastName"
                                        data-qa="register-page-lastname-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="Email"/>}</label>
                            <FormattedMessage id="Email" defaultMessage="Email">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="email"
                                        onChange={e => handleOnChange(e, "email")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="email"
                                        data-qa="register-page-email-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>



                        <div className="row">
                            <label>{<FormattedMessage id="Password"/>}</label>
                            <FormattedMessage id="Password" defaultMessage="Password">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="password"
                                        onChange={e => handleOnChange(e, "password")}
                                        maxLength={100}
                                        // placeholder={placeholder}
                                        autoComplete="user-pwd"
                                        id="pwd"
                                        value={state.password}
                                        data-qa="register-page-pwd-input"

                                    />
                                }
                            </FormattedMessage>
                        </div>

                        {/*<div className="row">*/}
                        {/*    <label>{<FormattedMessage id="Birthdate"/>}</label>*/}
                        {/*    <FormattedMessage id="Birthdate" defaultMessage="Birthdate">*/}
                        {/*        {placeholder =>*/}
                        {/*            <input*/}
                        {/*                className="input"*/}
                        {/*                type="date"*/}
                        {/*                onChange={e => handleOnChange(e, "birthDay")}*/}
                        {/*                autoComplete="off"*/}
                        {/*                id="date"*/}
                        {/*                data-qa="register-page-birthdate-input"*/}
                        {/*            />*/}
                        {/*        }*/}
                        {/*    </FormattedMessage>*/}
                        {/*</div>*/}


                    </div>


                    {/*<div className="row">*/}
                    {/*    <label className="radio" htmlFor="option">*/}
                    {/*        <input*/}
                    {/*            type="radio"*/}
                    {/*            value="MALE"*/}
                    {/*            name="MALE"*/}
                    {/*            checked={state.gender === "MALE"}*/}
                    {/*            onChange={e => handleOnChange(e, "gender")}*/}
                    {/*            data-qa="register-page-gender-male-radio"*/}
                    {/*        />*/}
                    {/*        <span className="checkround"></span>*/}
                    {/*        <FormattedMessage id="Man"/>*/}
                    {/*    </label>*/}

                    {/*    <label className="radio" htmlFor="option">*/}
                    {/*        <input*/}
                    {/*            type="radio"*/}
                    {/*            value="FEMALE"*/}
                    {/*            name="FEMALE"*/}
                    {/*            checked={state.gender === "FEMALE"}*/}
                    {/*            onChange={e => handleOnChange(e, "gender")}*/}
                    {/*            data-qa="register-page-gender-female-radio"*/}
                    {/*        />*/}
                    {/*        <span className="checkround"></span>*/}
                    {/*        <FormattedMessage id="Woman"/>*/}
                    {/*    </label>*/}
                    {/*</div>*/}

                    {/*<div className="optional-msg">*/}
                    {/*    <FormattedMessage id="BirthdateAndGenderAreOptional"/>*/}
                    {/*</div>*/}

                    <div className="row">
                        <a onClick={() => registerAccount()}
                           className="btn btn-md btn-default uppercase register-btn"
                           data-qa="register-page-register-account-btn">
                            <FormattedMessage id="Register" defaultMessage="Register"/>
                        </a>
                    </div>

                    <div className="optional-msg">
                        <FormattedMessage id="BySigningUpYouAgreeWithPrivacyAndTerms"
                                          values={{
                                              privacyPolicyLink:<>
                                                  <span>&nbsp;</span>
                                                  <a target="_blank"
                                                     href="https://www.zoniz.com/data-privacy.html"
                                                     data-qa="register-page-data-privacy-link">
                                                      <FormattedMessage id="PrivacyPolicy"/>
                                                  </a>
                                                  <span>&nbsp;</span>
                                              </>
                                             ,
                                              termsAndConditionsLink:
                                              <>
                                                  <span>&nbsp;</span>
                                                  <a target="_blank"
                                                                         href="https://www.zoniz.com/terms-and-conditions.html"
                                                                         data-qa="register-page-terms-and-cond-link"><FormattedMessage
                                                  id="TermsAndConditions"/>
                                              </a>
                                              </>
                                          }}/>

                    </div>

                </div>


                {state.errorMsg != null ?
                    <div data-qa="register-page-error-div" className="error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                    </div>
                    : null
                }
            </div>
        </div>

    );
}

export default Register;
